import React from 'react';
import styles from './FaqDeprecated.module.scss';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { SFButton } from 'sfui';
import { LinkList } from '../../../Components/LinkList/LinkList';
import { LinkListElement } from '../../../Components/LinkList/LinkListElement/LinkListElement';
import { getFaqsByIds } from '../../../Helpers';
import { AppConfig, Faq } from '../../../Models';

export interface FaqDeprecatedProps {
  faq: Faq;
}

export const FaqDeprecated = ({
  faq
}: FaqDeprecatedProps): React.ReactElement<FaqDeprecatedProps> => {
  const navigate = useNavigate();
  const config = useOutletContext<AppConfig>();

  const message: string = `This answer was deprecated${
    faq.is_replaced_with ? ' and replaced' : ''
  }.`;

  const related: Faq[] =
    !faq.is_replaced_with && faq.related_questions
      ? getFaqsByIds(config, faq.related_questions)
      : [];

  return (
    <div className={styles.faqDeprecated}>
      <h2 className={styles.title}>{faq.question}</h2>

      <div className={styles.message}>{message}</div>

      {faq.is_replaced_with && (
        <div className={styles.replace}>
          <h3>Here is the answer that could help you:</h3>
          <SFButton
            variant="outlined"
            size="large"
            onClick={() => navigate(`/faq/${faq.is_replaced_with}`)}
          >
            Go to the Answer
          </SFButton>
        </div>
      )}

      {!faq.is_replaced_with && related.length > 0 && (
        <div className={styles.related}>
          <h3>Here are answers that could help you:</h3>
          <LinkList className={styles.relatedFaq}>
            {related.map((faq: Faq) => (
              <LinkListElement
                key={faq.id}
                to={`/faq/${faq.id}`}
                label={faq.question}
              />
            ))}
          </LinkList>
        </div>
      )}
    </div>
  );
};
